import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from "@nx/mono-common";

@Component({
  selector: 'mono-common-mobile-register-sign-in-bar',
  templateUrl: './mobile-register-sign-in-bar.component.html'
})
export class MobileRegisterSignInBarComponent implements OnInit {

  @Input() signInLinkPath: string;
  @Input() registrationLinkPath: string;
  @Input() language: string;

  constructor(private router: Router, private translateService: TranslateService) { }

  ngOnInit(): void {
  }

  public signInButtonClicked() {
    this.router.navigate([`${this.signInLinkPath}`]);
  }

  public registerButtonClicked() {
    this.router.navigate([`${this.registrationLinkPath}`]);
  }

  public translate(template: string) {
    return this.translateService.translate(template, this.language);
  }
}
